import React from 'react';
import './DocumentCard.css';

/**
 * Layout helper of the document cards (PZ, WZ, purchase invoice, truck) on the
 * object-card body (two equal columns, DESIGN.md direction 2026-10-19): half
 * sections pair up in order, a wide one takes the row, and a half section left
 * without a partner spans the row too, so no row has a lonely half.
 */
export interface CardSlot {
  key: string;
  /** Always spans both columns (items tables, histories). */
  wide?: boolean;
  render: (wide: boolean) => React.ReactNode;
}

export const layoutCardSlots = (slots: Array<CardSlot | null | false | undefined>): React.ReactNode[] => {
  const present = slots.filter((slot): slot is CardSlot => Boolean(slot));
  const out: React.ReactNode[] = [];
  let pending: CardSlot | null = null;
  present.forEach((slot) => {
    if (slot.wide) {
      if (pending) out.push(<React.Fragment key={pending.key}>{pending.render(true)}</React.Fragment>);
      pending = null;
      out.push(<React.Fragment key={slot.key}>{slot.render(true)}</React.Fragment>);
      return;
    }
    if (pending) {
      out.push(<React.Fragment key={pending.key}>{pending.render(false)}</React.Fragment>);
      out.push(<React.Fragment key={slot.key}>{slot.render(false)}</React.Fragment>);
      pending = null;
      return;
    }
    pending = slot;
  });
  if (pending) out.push(<React.Fragment key={(pending as CardSlot).key}>{(pending as CardSlot).render(true)}</React.Fragment>);
  return out;
};
